import capabilities from '@/lib/ondit/capabilities.json'
import type { BlockConfig } from '@/blocks/types'
import { OnditBlock } from './ondit'

const initial: Record<string, unknown> = {
  recommend: { page_ids: [], min_count: 3, max_count: 5 },
  adapt: { brief_id: '', revision: 1 },
  save: { brief_id: '', revision: 1, drafts: [] },
  confirm: { brief_id: '', revision: 1 },
  schedule: { brief_id: '', revision: 1 },
  status: { brief_id: '' },
  cancel: { brief_id: '', revision: 1, job_id: '' },
}
export const DistributionOperations = Object.fromEntries(
  capabilities
    .filter(
      (c) =>
        Object.hasOwn(initial, c.id.replace('distribution.', '')) &&
        c.id.startsWith('distribution.')
    )
    .map((operation) => {
      const name = operation.id.replace('distribution.', '')
      const type = `ondit_distribution_${name}`
      return [
        type,
        {
          ...OnditBlock,
          type,
          name: operation.label[0],
          description: operation.label[0],
          subBlocks: OnditBlock.subBlocks.map((field) =>
            field.id === 'capability'
              ? {
                  id: 'capability',
                  title: '',
                  type: 'short-input',
                  defaultValue: operation.id,
                  hidden: true,
                }
              : field.id === 'inputs'
                ? { ...field, defaultValue: JSON.stringify(initial[name]) }
                : field
          ),
        } as BlockConfig,
      ]
    })
) as Record<string, BlockConfig>
